import { authApi } from 'api';

// export const getAthletePoints = async (clubId, seasonId, athleteId) => {
//   let url = `/reports/athlete-points?clubId=${clubId}`;
//   if (seasonId) {
//     url += `&seasonId=${seasonId}`;
//   }
//   if (athleteId) {
//     url += `&seasonId=${athleteId}`;
//   }
//   return authApi.get(url);
// };



// export const recalculateAthletePoints = async (clubId, seasonId) => {
//   return authApi.post('/reports/recalculate-athlete-points', {
//     clubId,
//     seasonId,
//   });
// };



// NEW Athlete Points endpoints
export const getAthleteSeasonPoints = async (clubId) => {
  return authApi.get(`/athlete-points/club/${clubId}/season`);
};

export const recalculateAthleteSeasonPoints = async (clubId) => {
  return authApi.post('/athlete-points/recalculate', {
    clubID: clubId,
  });
};

// Both season points files list athletes in the order chosen in the report's
// Sort by list: sortBy is 'points' or 'group' (utils/athleteOrder.js).
export const exportAthleteSeasonPointsToFile = async (clubId, sortBy) => {
  return authApi.post(`/athlete-points/club/${clubId}/export-csv`, null, {
    params: { sortBy },
    responseType: 'blob',
  });
};

// Season Champions (points slice 6): each group and gender's top 3 over the active
// season, for clubs and schools. The reply carries the season's name for the
// page's subtitle.
export const getSeasonChampions = async (clubId) => {
  return authApi.get(`/athlete-points/club/${clubId}/season-champions`);
};

export const exportSeasonChampionsToFile = async (clubId) => {
  return authApi.post(`/athlete-points/club/${clubId}/season-champions/export-csv`, null, {
    responseType: 'blob',
  });
};

// House Points (points slice 5), a school's report: each house's points over the
// active season, a column per meet that counts for season points. The reply
// carries the season's name for the page's subtitle.
export const getHousePoints = async (clubId) => {
  return authApi.get(`/athlete-points/club/${clubId}/house-points`);
};

export const exportHousePointsToFile = async (clubId) => {
  return authApi.post(`/athlete-points/club/${clubId}/house-points/export-csv`, null, {
    responseType: 'blob',
  });
};

// Matrix CSV (athlete rows x meet columns) from the stored AthleteMeetPoints
// breakdown — always consistent with the season report; 404s with a
// "recalculate first" message if no breakdown exists for the season yet.
export const exportAthleteSeasonPointsMeetBreakdownToFile = async (clubId, sortBy) => {
  return authApi.post(`/athlete-points/club/${clubId}/export-meet-breakdown-csv`, null, {
    params: { sortBy },
    responseType: 'blob',
  });
};


export const getVolunteerPoints = async (clubId, seasonId, volunteerUserId) => {
  let url = `/reports/volunteer-points?clubId=${clubId}`;
  if (seasonId) {
    url += `&seasonId=${seasonId}`;
  }
  if (volunteerUserId) {
    url += `&volunteerUserId=${volunteerUserId}`;
  }
  return authApi.get(url);
};

export const recalculateVolunteerePoints = async (clubId, seasonId) => {
  return authApi.post('/reports/recalculate-volunteer-points', {
    clubId,
    seasonId,
  });
};

export const getAthletePrReportFilters = async (clubId) => {
  return authApi.get(`/reports/athlete-pr-report/filters?clubId=${clubId}`);
}

export const getAthletePrReport = async (payload) => {
  return authApi.post('/reports/athlete-pr-report', payload);
}

export const exportAthletePrReportToFile = async (payload) => {
  return authApi.post('/reports/athlete-pr-report/export-csv', payload, {
    responseType: 'blob',
  });
}

// The same season bests as a ResultsHQ import file (Excel), the file Event View's
// "ResultsHQ Excel" export writes.
export const exportAthletePrReportToResultsHQ = async (payload) => {
  return authApi.post('/reports/athlete-pr-report/export-resultshq', payload, {
    responseType: 'blob',
  });
}

export const exportVolunteerHoursReportToFile = async (clubId, seasonId) => {
  let url = `/reports/volunteer-points/export-csv?clubId=${clubId}`;
  if (seasonId) {
    url += `&seasonId=${seasonId}`;
  }
  return authApi.post(url, null, {
    responseType: 'blob',
  });
}

// Event Participation Report endpoints
// pointsEligibleOnly: true counts only meets that count for season points; false counts every meet with results
export const getEventParticipationReport = async (clubId, pointsEligibleOnly) => {
  return authApi.post('/Reports/event-participation', {
    clubId,
    pointsEligibleOnly,
  });
};

export const exportEventParticipationReportToFile = async (clubId, pointsEligibleOnly) => {
  return authApi.post('/Reports/event-participation/export-csv', {
    clubId,
    pointsEligibleOnly,
  }, {
    responseType: 'blob',
  });
};

// Athlete Attendance Report endpoints
export const getAthleteAttendanceReport = async (clubId) => {
  return authApi.post('/Reports/athlete-attendance', {
    clubId,
  });
};

export const exportAthleteAttendanceReportToFile = async (clubId) => {
  return authApi.post('/Reports/athlete-attendance/export-csv', {
    clubId,
  }, {
    responseType: 'blob',
  });
};

// Most Meet PRs Report endpoints
export const getMostMeetPRsReport = async (clubId, minPrsInMeet) => {
  return authApi.post('/Reports/athlete-single-meet-pr', {
    clubId,
    minPrsInMeet,
  });
};

export const exportMostMeetPRsReportToFile = async (clubId, minPrsInMeet) => {
  return authApi.post('/Reports/athlete-single-meet-pr/export-csv', {
    clubId,
    minPrsInMeet,
  }, {
    responseType: 'blob',
  });
};

// Season Event Performance endpoints
export const getSeasonEventPerformance = async (clubId) => {
  return authApi.post('/Reports/athlete-event-performance', { clubId });
};

export const exportSeasonEventPerformanceToFile = async (clubId) => {
  return authApi.post('/Reports/athlete-event-performance/export-csv', { clubId }, {
    responseType: 'blob',
  });
};

// Meet Points Dashboard endpoints
export const getMeetPointsDashboard = async (meetId, includeZeroPoints = false) => {
  return authApi.get(`/athlete-points/meet/${meetId}/dashboard?includeZeroPoints=${includeZeroPoints}`);
};

export const exportMeetPointsToFile = async (meetId, includeZeroPoints = false) => {
  return authApi.post(`/athlete-points/meet/${meetId}/export-csv?includeZeroPoints=${includeZeroPoints}`, null, {
    responseType: 'blob',
  });
};

// Who sees the Points page (points slice 4b): 'admins' or 'members' (TEAM_TOTALS_VISIBILITY).
export const setMeetTeamTotalsVisibility = async (meetId, visibility) => {
  return authApi.put(`/athlete-points/meet/${meetId}/team-totals-visibility`, { visibility });
};

// Bonus points on the Points page (points slice 4c), Admins only: line is { teamId, points, reason }.
export const addMeetBonusPoints = async (meetId, line) => {
  return authApi.post(`/athlete-points/meet/${meetId}/bonus-points`, line);
};

export const changeMeetBonusPoints = async (meetId, lineId, line) => {
  return authApi.put(`/athlete-points/meet/${meetId}/bonus-points/${lineId}`, line);
};

export const deleteMeetBonusPoints = async (meetId, lineId) => {
  return authApi.delete(`/athlete-points/meet/${meetId}/bonus-points/${lineId}`);
};
